/* eslint-disable */
// @ts-nocheck
import dash_api from '../../main/support/dash_api';
type AppData = {
  imageUrl: string;
  name: string;
};
const APPLE_URL = '/v1/external-app-store/apple-store-load';
const ANDROID_URL = '/v1/external-app-store/google-play-load';
export function getIosAppStoreAppData(options: { id: string; country?: string }): AppData {
  const { id, country = 'US' } = options;
  return dash_api
    .get(APPLE_URL, {
      params: {
        id,
        country,
      },
    })
    .then(({ data }) => data);
}
export function getGooglePlayStoreAppData(options: { id: string }): AppData {
  const { id } = options;
  return dash_api
    .get(ANDROID_URL, {
      params: {
        id,
      },
    })
    .then(({ data }) => data);
}
